import { graphql } from '@api/generated';

export const GET_CONTACT_CENTER_SETTINGS = graphql(`
  query contactCenterSettings {
    contactCenterSettings {
      showWorkflowNameOnInboundCalls {
        isEnabled
      }
      callTimeoutWarning {
        isEnabled
      }
    }
  }
`);
